import { Component, OnInit ,ViewChild} from '@angular/core';
import { MatPaginator, MatSort } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Kardex } from 'src/app/modelos/kardex';
import { KardexService } from 'src/app/services/kardex.service';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-relacion-kardexs',
  templateUrl: './relacion-kardexs.component.html',
  styleUrls: ['./relacion-kardexs.component.css']
})
export class RelacionKardexsComponent implements OnInit {
  kardex: Kardex = new Kardex();


  displayedColumns: string[] = ['Kardex','FechaIngreso','Contrato','Referencia'];
    
    public data : any = null; 
    resultsLength = 0;
    //isLoadingResults = true;
    ///isRateLimitReached = false;
    //pagina  = 1;
    cantidadRegistrosPorPagina = 10;
    @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(private kardexService:KardexService,private rutaActiva: ActivatedRoute, private spinner: NgxSpinnerService) { }
 
  ngOnInit() {
    
  }


 

  ngAfterViewInit() {  
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    this.loadData();
  }

  loadData(){
    
    
    this.spinner.show();
    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
      startWith({}),
      switchMap(() => {
        // this.isLoadingResults = true;
        let request = {
          numeroDocumento: this.rutaActiva.snapshot.params.documento,
          inStart: this.paginator.pageIndex + 1,
          inLimit:this.cantidadRegistrosPorPagina
        }
        return this.kardexService.GetKardexsPorDocumentoContratante(request);
      }),
      map(data => {
         this.spinner.hide();
        // Flip flag to show that loading has finished.
      //  this.isLoadingResults = false;
      //  this.isRateLimitReached = false;
        this.resultsLength = data.total;

        return data.kardexs;
      }),
      catchError(() => {
        this.spinner.hide();
        // Catch if the GitHub API has reached its rate limit. Return empty data.
    //    this.isRateLimitReached = true;
        return observableOf([]);
      })
    ).subscribe(data => 
      
      this.data = data
      );


  }

}
